import { render } from "./breadcrumb1.vue?vue&type=template&id=23db4532"
import script from "./breadcrumb1.vue?vue&type=script&lang=js"
export * from "./breadcrumb1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__